import axios from 'axios'
import store from '../store'
const qs = require('qs');
const md5 = require('../plugins/md5.js');
import { Message } from 'element-ui'
//import { showFullScreenLoading, tryHideFullScreenLoading } from '@/utils/loading'

// create an axios instance
/*axios.defaults.headers = {
  'Content-type': 'application/x-www-form-urlencoded'
}*/

const service = axios.create({
    //baseURL: 'http://192.168.110.127:8881/',//process.env.VUE_APP_BASE_API, // url = base url + request url
    baseURL: 'http://121.41.72.53',//process.env.VUE_APP_BASE_API, // url = base url + request url
    withCredentials: true,
    timeout: 30000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        //showFullScreenLoading();
        // do something before request is sent
        let time=new Date().getTime();
        config.headers.sign=md5.hexMD5(config.url+'mrml'+time);
        config.headers.timelong=time;
        if(localStorage.getItem('access_token')){
            config.headers.ACCESS_TOKEN=localStorage.getItem('access_token').replace(/\"/g,'')
        }else{
            //console.log('res.config',config,config.url.indexOf('/noJwt/'));
            if(config.url.indexOf('/noJwt/') == -1){
                store.commit('changeLoginShow',true);
                return Promise.reject(new Error( '请先登录'))
            }
        }
        const method = config.method;
        if( method === 'post' ) {

            config.data = config.data instanceof FormData ? config.data : qs.stringify(config.data);
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data;
        //tryHideFullScreenLoading();
        // if the custom code is not 20000, it is judged as an error.
        if (res.code>=2000) {
            Message({
                message: res.msg || '服务器发生异常',
                type: 'error',
                duration: 5 * 1000
            });
            if(res.code==2002){
                store.dispatch('logout');
            }
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    },
    error => {
        //tryHideFullScreenLoading()
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service